import { useSizes } from '@hg/stylizator/hooks'
import { Text } from '@hg/stylizator/typography'
import { Flex, desktop } from '@hg/stylizator/utils'
import * as React from 'react'
import styled, { useTheme } from 'styled-components'

import Post from 'app/components/blog/Post'
import Separator from 'app/components/blog/Separator'
import ViewAllLink from 'app/components/blog/ViewAllLink'
import { Topic as ITopic } from 'app/service/api/theme/post-home-data'

interface IProps {
  topic: ITopic
  withSeparator?: boolean
}

const Topic: React.FC<IProps> = ({ topic, withSeparator }) => {
  const theme = useTheme()
  const { isDesktop } = useSizes()

  return (
    <>
      <Flex justify="space-between" align="center">
        <Text type="heading_medium" useCompact>
          <h2>{topic.name}</h2>
        </Text>

        <Text type="compact_label" color={theme.color.blue[60]}>
          <ViewAllLink href={topic.url} />
        </Text>
      </Flex>

      <TopicPostList>
        {topic.posts.slice(0, isDesktop ? 3 : 4).map((post) => (
          <Post key={post.permalink} variant="medium" post={post} />
        ))}
      </TopicPostList>
      {withSeparator && <TopicSeparator />}
    </>
  )
}

const TopicPostList = styled.div`
  display: grid;
  margin-top: 24px;
  gap: 24px 16px;
  grid-template-columns: repeat(2, 1fr);

  @media ${desktop} {
    grid-template-columns: repeat(3, 1fr);
    column-gap: 24px;
    margin-top: 32px;
  }
`

const TopicSeparator = styled(Separator)`
  margin: 40px 0;

  @media ${desktop} {
    margin: 72px 0;
  }
`

export default Topic
